import { Scenario } from "@opstel/query/api/scenario";
import { useEffect, useState } from "react";
import { useLocalStorageManager } from "./useLocalStorageManager";
import { UseQueryResult } from "@tanstack/react-query";

export interface PrepareStoreResult {
  readonly isStoreLoading: boolean;
}

type LoadingState = "Unloaded" | "Loading" | "Loaded";

export function usePrepareStore(
  scenario: Scenario | null | undefined,
  queries: readonly UseQueryResult[],
): PrepareStoreResult {
  const { prepareStore } = useLocalStorageManager();
  const [loadingState, setLoadingState] = useState<LoadingState>("Unloaded");

  const isLoading = queries.some((query) => query.isLoading);
  const isError = queries.some((query) => query.isError);

  useEffect(() => {
    if (isLoading) {
      setLoadingState("Loading");
    } else if (scenario && !isLoading && !isError) {
      prepareStore(scenario);
      setLoadingState("Loaded");
    } else {
      setLoadingState("Unloaded");
    }
  }, [scenario, isLoading, isError, prepareStore]);

  const isStoreLoading = loadingState === "Loading";

  return { isStoreLoading };
}
